import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Button, Row, Col, Select } from 'antd'
import { Header } from 'antd/lib/layout/layout'

const containerStyleCss = css`
  background-color: white;
  box-shadow: 0px 1px 2px rgba(74, 74, 104, 0.1);
  border-radius: 4px;
`

export const BackButton = styled(Button)`
  color: #4a4a68;
  border: 1px solid #4a4a68;

  &:hover {
    color: #4a4a68;
    border: 1px solid #4a4a68;
  }
`

export const TableHeaderTooltip = styled.div`
  display: flex;
  align-items: center;
  whitespace: nowrap;
`

export const TableCellNoWrap = styled.span`
  white-space: nowrap;
`

export const FormItemCol = styled(Col)`
  padding-right: 8px;
  &:not(:first-of-type) {
    padding-left: 0 !important;
  }
  & > .control {
    width: 100% !important;
  }
`

export const OverflowContainer = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  margin: 2px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CustomSorterRow = styled(Row)`
  min-width: max-content;
`

export const OrderStoreInfo = styled.div`
  > .name {
    font-weight: bold;
    color: #d092dd;
    margin-bottom: 4px;
  }

  > .zip {
    color: #4a4a68;
    margin-bottom: 0;
  }
`

export const wideOrderDrawerStyles = css`
  > .ant-drawer-content-wrapper {
    width: 720px !important;
  }

  > * > * > * > .ant-drawer-header-no-title {
    min-height: 174px;
  }
`

export const DrawerFixedHeader = styled.div`
  position: fixed;
  width: 720px;
  right: 0;
  top: 0;
  z-index: 1;
`

export const MainHeader = styled(Header)`
  box-shadow: 0px 1px 2px rgba(74, 74, 104, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 56px;
  padding: 0 48px;
  line-height: 56px;
  font-size: 0.75rem;

  @media (min-width: 1366px) {
    height: 64px;
    line-height: 64px;
  }
`

export const OnboardingContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  height: 100%;
  overflow-y: scroll;
  background-color: #f3f2f4;
  padding-bottom: 80px;

  div.ant-form-item-explain.ant-form-item-explain-error {
    margin: 4px 0 0 0;
    min-height: 8px;
  }

  .ant-form-item-label label {
    font-size: 0.875rem;
  }
`

export const ContainerStyleCol = styled(Col)`
  ${containerStyleCss}
`

export const ContainerStyleRow = styled(Row)`
  ${containerStyleCss}
`

export const StatsComponentSelect = styled(Select)`
  box-shadow: 0px 1px 2px rgba(216, 224, 234, 0.5);

  &:nth-child(1) {
    width: 100%;
    max-width: 240px;
  }

  &:nth-child(2) {
    width: 100%;
    max-width: 160px;
  }

  > div {
    border-radius: 4px !important;
  }
` as unknown as typeof Select
